import React, { useEffect } from 'react';
import '../../assets/css/styles.css';

const Reintentos = ({ countdown }) => {
    // FIX VISUAL: Inyectamos las clases al body para que se centre igual que el Login
    useEffect(() => {
        document.body.className = 'vertical-layout vertical-menu 1-column menu-expanded blank-page blank-page';
        document.body.setAttribute('data-col', '1-column');
    }, []);

    // Detectamos si estamos en modo espera automática o manual
    const isManualMode = countdown <= 0;

    // Calculamos porcentaje visual (base 60s o 5s)
    const maxTime = countdown > 5 ? 60 : 5; 
    const progress = isManualMode ? 100 : (countdown / maxTime) * 100;

    return (
        <div className="app-content content">
            <div className="content-wrapper">
                <div className="content-body">
                    {/* Video de fondo */}
                    <video className="video-login-bg" autoPlay muted loop>
                        <source src={process.env.PUBLIC_URL + "/images/videos-login/video1.mp4"} type="video/mp4"/>
                    </video>
                    
                    <section className="flexbox-container">
                        <div className="col-12 d-flex align-items-center justify-content-center">
                            <div className="col-md-4 col-10 box-shadow-2 p-0">
                                <div className="card border-grey border-lighten-3 px-2 py-2 m-0">
                                    <div className="card-header border-0 text-center" style={{ padding: 0 }}>
                                        <img 
                                            src={process.env.PUBLIC_URL + "/images/company/logo-login-app.png"} 
                                            alt="Logo" 
                                            className="rounded-circle img-fluid center-block" 
                                            style={{ maxHeight: '100px' }} 
                                        />
                                    </div>
                                    <div className="card-content">
                                        <div className="card-body" style={{ paddingTop: '1rem' }}>
                                            
                                            <div className="text-center">
                                                <div className="mb-2">
                                                    <i className={`la ${isManualMode ? 'la-wifi' : 'la-server spinner'} `} style={{ fontSize: '40px', color: isManualMode ? '#dc3545' : '#ff9800' }}></i>
                                                </div>
                                                
                                                <h4 className={`card-title font-weight-bold ${isManualMode ? 'text-danger' : 'text-warning'}`}>
                                                    {isManualMode ? "Inconvenientes en Sistema" : "Reintento de Recovery"}
                                                </h4>
                                                
                                                <p className="card-text text-muted mb-3">
                                                    {isManualMode
                                                        ? "No pudimos restablecer el Sistema de forma automática."
                                                        : (
                                                            <>
                                                                Detectamos inconvenientes en la Configuración de VEC Fleet.
                                                                <br />
                                                                Revalidando Setup . . .
                                                            </>
                                                        )
                                                    }
                                                </p>

                                                {/* Barra de progreso visual (Solo en automatico) */}
                                                {!isManualMode && (
                                                    <div className="progress mb-2" style={{height: '6px'}}>
                                                        <div className="progress-bar bg-warning" role="progressbar" style={{ width: `${progress}%`, transition: 'width 1s linear' }}></div>
                                                    </div>
                                                )}
                                                
                                                <div className="mb-3">
                                                    {!isManualMode ? (
                                                        <small className="text-muted">
                                                            Próximo intento en <strong>{countdown}</strong> segundos
                                                        </small>
                                                    ) : (
                                                        <small className="text-danger font-weight-bold">
                                                            Se requiere acción manual.
                                                        </small>
                                                    )}
                                                </div>

                                                <button 
                                                    className={`btn btn-block ${isManualMode ? 'btn-danger' : 'btn-outline-primary'}`}
                                                    onClick={() => window.location.reload()}
                                                >
                                                    <i className="la la-refresh"></i> Reintentar Ahora
                                                </button>
                                                
                                                <hr className="my-2" />
                                                <small className="text-muted">Si el problema persiste, contacte al Administrador.</small>
                                            </div>

                                            <div className="row mt-3">
                                                <div className="col-6">
                                                    <img src={process.env.PUBLIC_URL + "/images/company/logo-login-company.png"} alt="" className="img-fluid center-block" />
                                                </div>
                                                <div className="col-6 text-right">
                                                    <img src={process.env.PUBLIC_URL + "/images/company/logo-login-powered-by.png"} alt="" className="img-fluid center-block" />
                                                </div>
                                            </div>
                                            <div className="row justify-content-center mt-1">
                                                 <h5 className="login-version" style={{fontSize: '10px', color: '#999'}}>v{process.env.REACT_APP_VERSION}</h5>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    );
};

export default Reintentos;
